import { render, staticRenderFns } from "./DetectionResult.vue?vue&type=template&id=6f8d878e&scoped=true"
import script from "./DetectionResult.vue?vue&type=script&lang=js"
export * from "./DetectionResult.vue?vue&type=script&lang=js"
import style0 from "./DetectionResult.vue?vue&type=style&index=0&id=6f8d878e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d878e",
  null
  
)

export default component.exports